<div class="schedule-details-general w-100 h-100 m-0 p-0 scrollable-content">
  <div class="row dialog-header">
    <h1 class="d-flex justify-content-between text-center">
      @if (data.isPromotional) {
        <div class="promo ms-2">
          <img class="mb-1 ms-2" src="../assets/icons/promotional-icon/promotional-icon.png" alt="" />
        </div>
      }
      @if (getThirdPartyAppName(data.fromThirdPartyApp) != '') {
        <div>
          <span class="third-party-app">{{
            getThirdPartyAppName(data.fromThirdPartyApp)
          }}</span>
        </div>
      }
      @if (data.fromMobile) {
        <mat-icon class="icon-mobile">stay_primary_portrait</mat-icon>
      }
      <div class="d-flex justify-content-center flex-grow-1">
        <span class="dialog-header-title">{{ data.jobGroup }} {{ data.taskType }}</span>
      </div>
      <button (click)="onNoClick()" type="button" class="invisible-button dialog-header-close material-icons" aria-label="Cerrar">
        <span title="Cerrar">close</span>
      </button>
    </h1>
  </div>
  <div class="actions-bar">
    <div class="actions">
      @if (anyMenuItemVisible) {
        <app-icon-menu-button [menu]="menu"></app-icon-menu-button>
      }

      <mat-menu #menu="matMenu" name="edit">

        <!-- Ítems que dependen de estado/permisos -->
        @if (userCanEditTask()) {
          <button mat-menu-item (click)="enableEdition()">
            Editar
          </button>
        }

        @if (
          (usrSvc.hasPermission('cancel:workload') ||
          (usrSvc.hasPermission('cancel:terrain') && data.taskTypeId == TERRAIN_VISIT_ID)) &&
          validateNotStatusList(data.status, ['Cancelada','Finalizada','Cerrada'])
          ) {
          <button mat-menu-item (click)="action = 'Delete'">
            Cancelar
          </button>
        }

        @if (validateStatusList(data.status, ['Creada','Agendada']) &&
          usrSvc.hasPermission('postponed:workload')) {
          <button mat-menu-item (click)="action = 'Posponer'">
            Posponer
          </button>
        }

        @if (validateStatusList(data.status, ['Creada']) &&
          usrSvc.hasPermission('postponed:workload')) {
          <button mat-menu-item (click)="action = 'Presupuestar'">
            Presupuestar
          </button>
        }

        <button mat-menu-item *appHideIfNoPermission="'change:task-client'" (click)="openClientInfo()">
          Cambiar cliente y domicilio
        </button>

        @if (canGenerateTask()) {
          <button mat-menu-item (click)="generateTask()">
            Generar tarea
          </button>
        }

      </mat-menu>
    </div>

    @if (
      usrSvc.hasPermission('uncancel:workload') &&
      validateCancelStatus(data.status)
      ) {
      <div class="actions">
        <app-icon-menu-button [menu]="menuUncancel"></app-icon-menu-button>
        <mat-menu #menuUncancel="matMenu" name="edit">
          @if (
            usrSvc.hasPermission('uncancel:workload') &&
            validateNotStatusList(data.status, ['Finalizada', 'Cerrada'])
            ) {
            <button mat-menu-item (click)="uncancelTask(data.workloadId)">
              Descancelar
            </button>
          }
        </mat-menu>
      </div>
    }
  </div>

  <div class="container container-list px-0">

    <mat-tab-group class="customTabContainer" dynamicHeight mat-align-tabs="justify">
      <mat-tab label="Detalle de la tarea">
        <div class="row mt-1">
          <ul class="selectedTags">
            @for (tag of selectedTags; track tag) {
              <li>
                <div class="tag-preview tag-list-item" [style.background-color]="tag.color"
                  [ngStyle]="{ '--after-background-color': tag.color }">
                  <span class="remove-btn" title="Quitar etiqueta" (click)="removeTag(tag, data.id)"
                    (keydown.enter)="removeTag(tag, data.id)">
                    X
                  </span>
                  <span class="tag-label">{{ tag.name }}</span>
                </div>
              </li>
            }
          </ul>
        </div>
        <div class="detail-summary">
          <div class="detail-summary__col">
            <div><span class="detail-summary__label">Servicio:</span> {{ data.jobGroup }} {{ data.taskType }}</div>
            <div>
              <span class="detail-summary__label">Fecha programada:</span>
              {{ data.schudeledDate | date : "dd/MM/yyyy" }}
            </div>
            <div><span class="detail-summary__label">Producto:</span> {{ data.productName }}</div>
          </div>
          <div class="detail-summary__col">
            <div><span class="detail-summary__label">Cliente:</span> {{ data.clientName }}</div>
            <div>
              <span class="detail-summary__label">{{ data.clientIdentificationType }}:</span> {{ data.clientDni }}
            </div>
            <div class="detail-summary__inline">
              <span>
                <span class="detail-summary__label">Teléfono:</span>
                {{ data.clientPhone?.countryCode }}-{{ data.clientPhone?.number }}
              </span>
              @if (data.clientPhone?.number) {
                <a href="https://wa.me/{{ data.clientPhone?.countryCode }}{{
                    data.clientPhone?.number
                  }}" target="_blank" title="Enviar mensaje a {{ data.clientName }}">
                  <div class="wpp-button">
                    <img src="assets/icons/common/whatsapp.svg" alt="WhatsApp" />
                  </div>
                </a>
              }
            </div>
            <div>
              <span class="detail-summary__label">Domicilio:</span>
              {{ data.address?.street }} {{ data.address?.number }} {{ data.address?.neighborhood }}
              {{ data.address?.block }} {{ data.address?.parcel }}, {{ data.address?.city }} - {{ data.address?.state }}
              <button type="button" class="invisible-button detail-summary__map" title="Ver en Google Maps" (click)="
                  openGoogleMaps(
                    data.address?.coordinates.latitude,
                    data.address?.coordinates.longitude
                  )
                ">
                <mat-icon>place</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <mat-tab-group class="mt-4" dynamicHeight (selectedTabChange)="viewLog($event)">
          <mat-tab label="Detalle">
            <div class="mt-2" #containerSummary>
              @if (
                action != 'Delete' &&
                action != 'Posponer' &&
                action != 'Presupuestar'
                ) {
                <div class="detail-grid">
                  <section class="detail-card">
                    <h3 class="detail-card__title">Producto</h3>
                    <div class="detail-card__fields">
                      <form [formGroup]="franchiseForm">
                        @if (data?.franchiseName != null && action != 'Edit') {
                          <div class="detail-field detail-field--text" data-field="franchise">
                            <span><span class="detail-field__label">Franquicia:</span> {{ data?.franchiseName }}</span>
                          </div>
                        }
                        @if (action == 'Edit') {
                          <div class="detail-field" data-field="franchise">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>Franquicias</mat-label>
                                <mat-select id="franchis" formControlName="franchiseId">
                                  @for (fran of franchiseList; track fran) {
                                    <mat-option [value]="fran.id">
                                      {{ fran.name }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="detail-field__actions">
                              <button type="button" class="detail-action"
                                [disabled]="!hasChanged(franchiseForm, 'franchiseId', data.franchiseId)"
                                (click)="updateFranchise(data.id)">
                                Guardar
                              </button>
                            </div>
                          </div>
                        }
                      </form>
                      @if (data.productColorName && data.productQualityName) {
                        <form [formGroup]="productForm">
                          @if (action != 'Edit') {
                            <div class="detail-field detail-field--text" data-field="product">
                              <span><span class="detail-field__label">Color:</span> {{ data.productColorName }}</span>
                              <span><span class="detail-field__label">Calidad:</span> {{ data.productQualityName }}</span>
                            </div>
                          }
                          @if (action == 'Edit') {
                            <div class="detail-field" data-field="product">
                              <div class="detail-field__controls detail-field__controls--pair">
                                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                  <mat-label>Colores</mat-label>
                                  <mat-select id="colors" formControlName="productColorId">
                                    @for (color of colorList; track color) {
                                      <mat-option [value]="color.id">
                                        {{ color.color }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                  <mat-label>Calidad</mat-label>
                                  <mat-select id="quality" formControlName="productQualityId">
                                    @for (quality of productsQualityList; track quality) {
                                      <mat-option [value]="quality.id">
                                        {{ quality.name }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>
                              </div>
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action"
                                  [disabled]="
                                    !hasChanged(productForm, 'productColorId', data.productColorId) &&
                                    !hasChanged(productForm, 'productQualityId', data.productQualityId)
                                  "
                                  (click)="UpdateProduct(data.id)">
                                  Guardar
                                </button>
                              </div>
                            </div>
                          }
                        </form>
                      }
                      @if (action == 'Edit' && !canAsociateVisit) {
                        <form [formGroup]="visitForm">
                          <div class="detail-field" data-field="visit">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>Visitas</mat-label>
                                <mat-select formControlName="selectedVisitId">
                                  @for (visita of visitsList; track visita) {
                                    <mat-option [value]="visita.taskId">
                                      {{ visita.creationDate | date }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="detail-field__actions">
                              <button type="button" class="detail-action"
                                [disabled]="!hasChanged(visitForm, 'selectedVisitId', null)"
                                (click)="updateVisit()">
                                Guardar
                              </button>
                            </div>
                          </div>
                        </form>
                      }
                      @if (
                        action == 'Edit' &&
                        data?.jobGroup === 'Transporte' &&
                        data?.taskType === 'Carga' &&
                        usrSvc.hasPermission('distributioncenter:workload')
                        ) {
                        <form [formGroup]="centroDistribucionForm">
                          <div class="detail-field" data-field="distribution-center">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>Centro de Distribución</mat-label>
                                <mat-select formControlName="centroDistribucionId">
                                  @for (
                                    centroDistribucion of distributionsCenterList
                                    ; track
                                    centroDistribucion) {
                                    <mat-option [value]="centroDistribucion.id">
                                      {{ centroDistribucion.name }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="detail-field__actions">
                              <button type="button" class="detail-action"
                                [disabled]="!hasChanged(centroDistribucionForm, 'centroDistribucionId', data.distributionCenterId)"
                                (click)="updateDistribuionCenter()">
                                Guardar
                              </button>
                            </div>
                          </div>
                        </form>
                      }
                      @if (
                        action != 'Edit' &&
                        data?.jobGroup === 'Transporte' &&
                        data?.taskType === 'Carga'
                        ) {
                        <div class="detail-field detail-field--text" data-field="distribution-center">
                          <span><span class="detail-field__label">Centro de Distribución:</span> {{ data?.distributionCenterName }}</span>
                        </div>
                      }
                    </div>
                  </section>

                  <section class="detail-card">
                    <h3 class="detail-card__title">Garantía y obra</h3>
                    <div class="detail-card__fields">
                      @if (
                        editableWarrantyNumberAndPaidLabor() &&
                        data.externalIdentifier != null &&
                        data.poolWarrantyNumber != null
                        ) {
                        <form [formGroup]="warrantyForm">
                          <div class="detail-field" data-field="warranty">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>Número de garantía</mat-label>
                                <input matInput type="number" name="poolWarrantyNumber"
                                  onKeyPress="if(this.value.length==10) return false;"
                                  formControlName="poolWarrantyNumber" placeholder="{{ data.poolWarrantyNumber }}"
                                  maxlength="10" (keydown)="validateOnlyNumbers($event)" />
                              </mat-form-field>
                            </div>
                            @if (
                              action == 'Edit' &&
                              editableWarrantyNumberAndPaidLabor()
                              ) {
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action"
                                  [disabled]="!hasChanged(warrantyForm, 'poolWarrantyNumber', data.poolWarrantyNumber)"
                                  (click)="updateWarrantyNumber(data.externalIdentifier)">
                                  Guardar
                                </button>
                              </div>
                            }
                          </div>
                        </form>
                      }
                      @if (data.isPromotional) {
                        <form [formGroup]="promotionalTaskForm">
                          <div class="detail-field" data-field="discount">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>Descuento</mat-label>
                                <input matInput type="text" name="discountApplied"
                                  formControlName="discountApplied" placeholder="{{ data.discountApplied }}" />
                                <span matTextSuffix>%</span>
                              </mat-form-field>
                            </div>
                            @if (action == 'Edit') {
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action"
                                  [disabled]="!hasChanged(promotionalTaskForm, 'discountApplied', data.discountApplied)"
                                  (click)="updateDiscount(data.id)">
                                  Guardar
                                </button>
                              </div>
                            }
                          </div>
                        </form>
                      }
                      @if (
                        editableRevetmentSurplusTasks() ||
                        data.revetmentSurplus > 0
                        ) {
                        <form [formGroup]="revetmentSurplusForm">
                          <div class="detail-field" data-field="revetment">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>Excedente</mat-label>
                                <input matInput type="text" name="revetmentSurplus"
                                  formControlName="revetmentSurplus"
                                  placeholder="{{ data.revetmentSurplus }}" />
                                <span matTextSuffix>mts<sup>2</sup></span>
                              </mat-form-field>
                            </div>
                            @if (
                              action == 'Edit' && editableRevetmentSurplusTasks()
                              ) {
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action"
                                  [disabled]="!hasChanged(revetmentSurplusForm, 'revetmentSurplus', data.revetmentSurplus)"
                                  (click)="updateRevetmentSurplus(data.id)">
                                  Guardar
                                </button>
                              </div>
                            }
                          </div>
                        </form>
                      }
                      @if (
                        editableTaskDuration() && data.estimatedDuration != null
                        ) {
                        <form [formGroup]="durationForm">
                          <div class="detail-field" data-field="duration">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>Duración</mat-label>
                                <input matInput type="text" formControlName="estimatedDuration" placeholder="0"
                                  (keydown)="
                                    validateOnlyNumbers(
                                      $event,
                                      durationForm,
                                      'estimatedDuration',
                                      48
                                    )
                                  " />
                                <span matTextSuffix>hs</span>
                              </mat-form-field>
                            </div>
                            @if (action == 'Edit') {
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action"
                                  [disabled]="!hasChanged(durationForm, 'estimatedDuration', data.estimatedDuration)"
                                  (click)="updateDuration(data.id)">
                                  Guardar
                                </button>
                              </div>
                            }
                          </div>
                        </form>
                      }
                      @if (editSerialNumber()) {
                        <form [formGroup]="serialNumberForm" class="detail-card__fields">
                          <div class="detail-field" data-field="valve">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>N.º de serie de válvula</mat-label>
                                <input matInput type="text" formControlName="valveSelectorSerialNumber"
                                  placeholder="{{ data.valveSelectorSerialNumber }}"
                                  onKeyPress="if(this.value.length==7) return false;" />
                              </mat-form-field>
                            </div>
                            @if (action == 'Edit') {
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action"
                                  [disabled]="!hasChanged(serialNumberForm, 'valveSelectorSerialNumber', data.valveSelectorSerialNumber)"
                                  (click)="updateValveSelectorSerialNumber()">
                                  Guardar
                                </button>
                              </div>
                            }
                          </div>
                          <div class="detail-field" data-field="filter">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>N.º de serie de filtro</mat-label>
                                <input matInput type="text" formControlName="filterSerialNumber"
                                  placeholder="{{ data.filterSerialNumber }}"
                                  onKeyPress="if(this.value.length==7) return false;" />
                              </mat-form-field>
                            </div>
                            @if (action == 'Edit') {
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action"
                                  [disabled]="!hasChanged(serialNumberForm, 'filterSerialNumber', data.filterSerialNumber)"
                                  (click)="updateFilterSerialNumber()">
                                  Guardar
                                </button>
                              </div>
                            }
                          </div>
                        </form>
                      }
                      @if (
                        editableDeliveryOrder() && data.deliveryOrder != null
                        ) {
                        <form [formGroup]="deliveryOrderForm">
                          <div class="detail-field" data-field="delivery-order">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>Orden de entrega</mat-label>
                                <input matInput type="text" formControlName="deliveryOrder"
                                  placeholder="{{ data.deliveryOrder }}" (keydown)="
                                    validateOnlyNumbers(
                                      $event,
                                      deliveryOrderForm,
                                      'deliveryOrder',
                                      99
                                    )
                                  " />
                              </mat-form-field>
                            </div>
                            @if (action == 'Edit') {
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action"
                                  [disabled]="!hasChanged(deliveryOrderForm, 'deliveryOrder', data.deliveryOrder)"
                                  (click)="updateDeliveryOrder(data.id)">
                                  Guardar
                                </button>
                              </div>
                            }
                          </div>
                        </form>
                      }
                      @if (
                        editableWarrantyNumberAndPaidLabor() ||
                        usrSvc.hasPermission('view:pendingContactFilter')
                        ) {
                        <!-- Both checkboxes save as soon as they change (no Guardar), as before. -->
                        <div class="detail-field detail-field--checks" data-field="checks">
                          @if (editableWarrantyNumberAndPaidLabor()) {
                            <form [formGroup]="paidLaberForm">
                              <mat-checkbox formControlName="isPaidLabor"
                                (change)="onPaidLaborChange($event, data.id)">
                                Mano de obra pagada
                              </mat-checkbox>
                            </form>
                          }
                          @if (usrSvc.hasPermission('view:pendingContactFilter')) {
                            <form [formGroup]="pendingContactForm">
                              <mat-checkbox formControlName="hasClientContact" (change)="onContactChange($event, data.id)">
                                Contacto con el cliente
                              </mat-checkbox>
                            </form>
                          }
                        </div>
                      }
                    </div>
                  </section>

                  <section class="detail-card detail-card--wide">
                    <h3 class="detail-card__title">Comentarios adicionales *</h3>
                    <div class="detail-card__fields">
                      <form [formGroup]="details">
                        <div class="detail-field" data-field="comments">
                          <div class="detail-field__controls">
                            <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
                              <mat-label>Comentarios</mat-label>
                              <textarea matInput matTextareaAutosize="5" type="text" placeholder="Haz tu comentario."
                                name="details" formControlName="details" [rows]="4" required>
                              </textarea>
                            </mat-form-field>
                          </div>
                          @if (action == 'Edit') {
                            <div class="detail-field__actions">
                              <button type="button" class="detail-action"
                                [disabled]="!hasChanged(details, 'details', data.details)"
                                (click)="updateTaskDescription(data.id)" title="Guardar comentario">
                                Guardar
                              </button>
                            </div>
                          }
                        </div>
                      </form>
                    </div>
                  </section>

                  <section class="detail-card detail-card--wide">
                    <h3 class="detail-card__title">Asignación y agenda</h3>
                    <div class="detail-card__fields">
                      @if (action != 'Edit') {
                        <div class="detail-field detail-field--text" data-field="assignment">
                          <span>
                            <span class="detail-field__label">Prestador asignado:</span>
                            {{
                            !currentContractorName || currentContractorName == ""
                            ? "Sin asignar"
                            : currentContractorName
                            }}
                          </span>
                          <span>
                            <span class="detail-field__label">Fecha programada:</span>
                            {{ getScheduleInfoLabel() | date : "dd/MM/yyyy hh:mma" }}
                          </span>
                        </div>
                      }
                      @if (action == 'Edit') {
                        <form [formGroup]="contractor">
                          <div class="detail-field" data-field="contractor">
                            <div class="detail-field__controls">
                              <mat-form-field appearance="outline" class="contractor-field" subscriptSizing="dynamic">
                                <mat-label>Prestador</mat-label>
                                <input type="text" placeholder="Seleccione un prestador" matInput
                                  formControlName="contractorName" [matAutocomplete]="auto" />
                                <mat-autocomplete #auto="matAutocomplete">
                                  @if (waitingCustomers) {
                                    <mat-option style="font-size: unset">Buscando
                                    prestadores...</mat-option>
                                  }
                                  @for (option of filteredOptions | async; track option) {
                                    <mat-option (click)="optionClicked($event, option)"
                                      [value]="option.fullName" tabindex="0"
                                      onkeydown="onKeyDownInSupplier($event, option)">
                                      {{ option.fullName }}
                                    </mat-option>
                                  }
                                </mat-autocomplete>
                              </mat-form-field>
                              @if (contractorError) {
                                <span class="contractor-error text-left">{{ contractorError }}</span>
                              }
                            </div>
                            @if (
                              usrSvc.hasPermission('add:assignContractor') ||
                              (usrSvc.hasPermission('add:assignContractorTerrain') &&
                              data.taskTypeId == TERRAIN_VISIT_ID)
                              ) {
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action detail-action--danger"
                                  [disabled]="data.contractorId == '00000000-0000-0000-0000-000000000000'"
                                  (click)="removeTaskConstractor(data.id)" title="Eliminar prestador asignado">
                                  Eliminar
                                </button>
                                <button type="button" class="detail-action" [disabled]="!selectedSupplier"
                                  (click)="updateTaskContractor(data.id)" title="Guardar cambio de prestador">
                                  Guardar
                                </button>
                              </div>
                            }
                          </div>
                        </form>
                        <form [formGroup]="schudeledDate">
                          <div class="detail-field" data-field="schedule">
                            <div class="detail-field__controls">
                              <div class="d-flex align-items-end date-time-row">
                                <mat-form-field class="date-field" appearance="outline" subscriptSizing="dynamic">
                                  <mat-label>Fecha programada</mat-label>
                                  <input matInput required (dateChange)="onDateChange()" [matDatepicker]="picker"
                                    formControlName="date" [min]="minDate" />
                                  @if (
                                    action == 'Edit' &&
                                    (usrSvc.hasPermission('add:schedule') ||
                                    (usrSvc.hasPermission('add:scheduleTerrain') &&
                                    data.taskTypeId == TERRAIN_VISIT_ID))
                                    ) {
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                  }
                                  <mat-datepicker #picker [disabled]="
                                      !(
                                        usrSvc.hasPermission('add:schedule') ||
                                        usrSvc.hasPermission('add:scheduleTerrain')
                                      )
                                    ">
                                  </mat-datepicker>
                                </mat-form-field>
                                <div class="timePickerRow">
                                  <span class="detail-field__label">Hora</span>
                                  <div class="ngx-timepicker-field">
                                    <ngx-timepicker-field matInput required formControlName="time"
                                      [toggleIcon]="icon" [format]="24" [defaultTime]="'00:00'" [min]="minHour">
                                    </ngx-timepicker-field>
                                    <ng-template #icon>
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30px" height="30px">
                                        <path
                                          d="M15,3C8.373,3,3,8.373,3,15c0,6.627,5.373,12,12,12s12-5.373,12-12C27,8.373,21.627,3,15,3z M16,16H7.995 C7.445,16,7,15.555,7,15.005v-0.011C7,14.445,7.445,14,7.995,14H14V5.995C14,5.445,14.445,5,14.995,5h0.011 C15.555,5,16,5.445,16,5.995V16z" />
                                      </svg>
                                    </ng-template>
                                  </div>
                                </div>
                              </div>
                            </div>
                            @if (
                              usrSvc.hasPermission('add:schedule') ||
                              (usrSvc.hasPermission('add:scheduleTerrain') &&
                              data.taskTypeId == TERRAIN_VISIT_ID)
                              ) {
                              <div class="detail-field__actions">
                                <button type="button" class="detail-action detail-action--danger"
                                  [disabled]="!data.schudeledDate"
                                  (click)="removeTaskSchedule(data.id)" title="Eliminar agenda">
                                  Eliminar
                                </button>
                                <button type="button" class="detail-action" [disabled]="disabledSchedule"
                                  (click)="updateTaskSchedule(data.id, false, data.hasClientContact)"
                                  title="Guardar cambios en agenda de tarea">
                                  Guardar
                                </button>
                              </div>
                            }
                          </div>
                          @if (
                            usrSvc.hasPermission('add:schedule') ||
                            (usrSvc.hasPermission('add:scheduleTerrain') &&
                            data.taskTypeId == TERRAIN_VISIT_ID)
                            ) {
                            <div class="detail-field__actions detail-field__actions--end" data-field="schedule-contacted">
                              <button type="button" class="detail-action" [disabled]="disabledSchedule"
                                (click)="updateTaskSchedule(data.id, false, true)"
                                title="Guardar la agenda y marcar que el cliente ya fue contactado">
                                Guardar y marcar cliente contactado
                              </button>
                            </div>
                          }
                        </form>
                      }
                    </div>
                  </section>
                </div>
              }
                            @if (action == 'Delete') {
                              <div>
                                <form [formGroup]="cancel">
                                  <div class="row">
                                    <div class="col-lg-8">
                                      <span class="float-left f-weight-500 mt-0">Comentario de cancelación *</span>
                                    </div>
                                    <div class="col-lg-4">
                                      @if (action == 'Delete') {
                                        <div class="float-right">
                                          <ul>
                                            <li>
                            <button class="d-flex cursor-pointer invisible-button" [ngClass]="{
                                disabled:
                                  !(cancel.controls['details'].value != '') ||
                                  taskCanceled ||
                                  taskClosed
                              }" (click)="cancelTask(data.id)" title="Cancelar tarea">
                                                Cancelar tarea
                                              </button>
                                            </li>
                                            @if (!taskCanceled) {
                                              <li>
                                                <button class="d-flex cursor-pointer invisible-button" type="button"
                                                  (click)="action = ''" title="Volver sin cancelar la tarea">
                                                  Volver
                                                </button>
                                              </li>
                                            }
                                          </ul>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                  <mat-form-field class="w-100 h-100" appearance="outline">
                                    <textarea matInput matTextareaAutosize="5" type="text" placeholder="Haz tu comentario."
                                      name="details" formControlName="details" [rows]="4" required>
                                    </textarea>
                                  </mat-form-field>
                                </form>
                              </div>
                            }
                          </div>
                          @if (['Posponer', 'Presupuestar'].includes(action)) {
                            <div>
                              <form [formGroup]="postponeOrToBudge">
                                <div class="row">
                                  <div class="col-lg-10">
                                    <span class="float-left f-weight-500 mt-0">Comentario *</span>
                                  </div>
                                  <div class="col-lg-2">
                                    @if (['Posponer', 'Presupuestar'].includes(action)) {
                                      <div class="float-right">
                                        <ul>
                                          <li>
                          <button class="d-flex cursor-pointer invisible-button" [ngClass]="{
                              disabled:
                                !(
                                  postponeOrToBudge.controls['details'].value !=
                                  ''
                                ) || taskPostponed
                            }" (click)="updateTaskStatus(data.id, action)">
                                              {{ action }}
                                            </button>
                                          </li>
                                        </ul>
                                      </div>
                                    }
                                  </div>
                                </div>
                                <mat-form-field class="w-100 h-100" appearance="outline">
                                  <textarea matInput matTextareaAutosize="5" type="text" placeholder="Haz tu comentario." name="details"
                                    formControlName="details" [rows]="4" required>
                                  </textarea>
                                </mat-form-field>
                              </form>
                            </div>
                          }
                        </mat-tab>
                        @if (
                          action != 'Delete' &&
                          action != 'Posponer' &&
                          action != 'Presupuestar'
                          ) {
                          <mat-tab label="Registro de actividad">
                            <div class="mt-2 scroll-table" [style.height.px]="height">
                              <app-activitiesLogs></app-activitiesLogs>
                            </div>
                          </mat-tab>
                        }
                      </mat-tab-group>
                    </mat-tab>
                    @if (data.hasSiteVisitReport && siteVisitCompletionFrom.length > 0) {
                      <mat-tab label="Visita de terreno">
                        <app-schedule-completion-form [clientdata]="data" [taskId]="data.id" [completionFroms]="siteVisitCompletionFrom"
                          (reloadImgsFromTaskEvent)="getForms()">
                        </app-schedule-completion-form>
                      </mat-tab>
                    }
                    @if (data.hasStartingReport && startingForms.length > 0) {
                      <mat-tab label="Detalle de inicio de obra">
                        <app-schedule-completion-form [clientdata]="data" [taskId]="data.id" [completionFroms]="startingForms"
                          (reloadImgsFromTaskEvent)="getForms()">
                        </app-schedule-completion-form>
                      </mat-tab>
                    }
                    @if (progressImages.length > 0) {
                      <mat-tab label="Avance de obra">
                        <div class="carousel-inner">
                          <ngb-carousel>
                            @for (file of progressImages; track file; let i = $index) {
                              <ng-template ngbSlide
                                class="carousel-item w-100 text-center">
                                @if (file.mediaType === 'image' || !file.mediaType) {
                                  <img class="d-block w-100" [src]="file.imageSrc" [alt]="'Slide ' + (i + 1)" [height]="600"
                                    (click)="openMedia(file.imageSrc)" (keydown.enter)="openMedia(file.imageSrc)" />
                                  }
                                  @if (file.mediaType === 'video') {
                                    <video class="d-block" [src]="file.imageSrc" controls [height]="600" (click)="openMedia(file.imageSrc)"
                                      (keydown.enter)="openMedia(file.imageSrc)">
                                      Your browser does not support the video tag.
                                    </video>
                                  }
                                </ng-template>
                              }
                            </ngb-carousel>
                          </div>
                        </mat-tab>
                      }
                      @if (data.hasEndingReport && completionFroms.length > 0) {
                        <mat-tab label="Detalle de fin de obra">
                          <app-schedule-completion-form [clientdata]="data" [taskId]="data.id" [completionFroms]="completionFroms"
                            (reloadImgsFromTaskEvent)="getForms()">
                          </app-schedule-completion-form>
                        </mat-tab>
                      }
                      @if (showTransportationReport() && transportationForms.length > 0) {
                        <mat-tab label="Remito">
                          <app-schedule-completion-form [clientdata]="data" [taskId]="data.id" [completionFroms]="transportationForms"
                            (reloadImgsFromTaskEvent)="getForms()">
                          </app-schedule-completion-form>
                        </mat-tab>
                      }
                      @if (data.hasEvaluationReport && evaluationForm.length > 0) {
                        <mat-tab
                          label="Detalle de encuesta de satisfacción">
                          <app-schedule-completion-form [clientdata]="data" [taskId]="data.id" [completionFroms]="evaluationForm"
                            (reloadImgsFromTaskEvent)="getForms()">
                          </app-schedule-completion-form>
                        </mat-tab>
                      }
                    </mat-tab-group>
                    <div class="detail-footer">
                      <span class="tp-badge task-status-badge">
                        <span class="status-dot" [style.background-color]="taskCurrentStatus?.selectedColor"></span>
                        {{ taskCurrentStatus?.name }}
                      </span>
                      @if (data.ownerName) {
                        <span class="schedule-owner">Creador: {{ data.ownerName }}</span>
                      }
                      <div class="dropdown-container" (click)="toggleDropdown()" (keydown.enter)="toggleDropdown()"
                        #dropdown>
                        <span class="dropdown-caption">Etiqueta</span>
                        <div class="dropdown-header" tabindex="0" role="button" aria-haspopup="listbox"
                          [attr.aria-expanded]="dropdownOpen">
                          <span class="dropdown-label">Seleccionar</span>
                          <mat-icon class="dropdown-icon" aria-hidden="true">expand_more</mat-icon>
                        </div>
                        @if (dropdownOpen) {
                          <div class="dropdown-list">
                            @for (tag of availableItems; track tag) {
                              <div class="w-100">
                                <div class="tag-preview tag-list-item" [style.background-color]="tag.color"
                                  [ngStyle]="{ '--after-background-color': tag.color }" (click)="selectTag(tag, $event, data.id)"
                                  (keydown.enter)="selectTag(tag, $event, data.id)">
                                  {{ tag.name }}
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 mt-3"></div>
                      <div class="col-6 mt-3">
                        @if (
                          usrSvc.hasPermission('cancel:workload') &&
                          validateStatusList(data.status, ['Finalizada']) &&
                          validateNotStatusList(data.status, ['Cancelada', 'Cerrada'])
                          ) {
                          <button mat-mdc-raised-button class="btnCloseTask ind-button float-right" type="button" (click)="CloseTask(data.id)">
                            <span>Cerrar tarea</span>
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </div>